export const researchEntries = [
 {
    id: "01",
    title: "History of IBD-Related Surgery Increases Time to Pregnancy in Women with Inflammatory Bowel Disease: Data from the Prospective Women with Inflammatory Bowel Disease and Motherhood (WIsDoM) Study",
    authors: "Gottlieb ZS, Shmidt E, Helmus D, Baker B, Wu B, Rajauria P, Persaud T, Cohen E, Cattaneo E, Dubinsky MC",
    date: "Digestive Disease Week (DDW) - May 2025",
    finding: "Our findings identified both older age and a history of pelvic IBD surgery as independent risk factors for prolonged time to pregnancy in women with IBD.",
    findingHighlight: "Poster of Distinction",
    highlight_link: "/files/DDW2025_FINAL 4.21.pdf",
    pdf_link: "/files/DDW2025_FINAL 4.21.pdf",
    category: "event"

  },
  {
    id: "02",
    title: "History of IBD Surgery Prolongs Time to Pregnancy: Updated Findings from the Prospective Women with Inflammatory Bowel Disease and Motherhood (WIsDoM) Study",
    authors: "Gottlieb ZS, Shmidt E, Cohen E, Horst SN, Bewtra M, Afzali A, Kane SV, Bonthala N, Dhere T, Cohen ER, Khanna P, Kellar A, Long MD, Gaidos J, Huff K, Helmus D, Wu B, Rajauria P, Persaud T, Dubinsky MC",
    date: "Digestive Disease Week (DDW) – May 2026",
    finding: "Early data from WIsDoM demonstrated that a history of pelvic IBD surgery and older age were associated with a significantly increased time to pregnancy.",
    findingHighlight: "Poster of Distinction",
    highlight_link: "/files/surg_poster_DDW_2026_v4.pdf",
    pdf_link: "/files/surg_poster_DDW_2026_v4.pdf",
    category: "event"
  },
  {
    id: "03",
    title: "Sexual Function and Wellbeing Differ Across Attempt-Duration Groups and Are Associated with Pregnancy Outcomes in Women with IBD: WIsDoM Study",
    authors: "Shmidt E, Gottlieb ZS, Cohen E, Horst SN, Bewtra M, Afzali A, Kane SV, Bonthala N, Dhere T, Cohen ER, Khanna P, Kellar A, Long MD, Gaidos J, Huff K, Helmus D, Wu B, Rajauria P, Persaud T, Dubinsky MC",
    date: "Digestive Disease Week (DDW) – May 2026",
    finding: "Our findings identified both older age and a history of pelvic IBD surgery as independent risk factors for prolonged time to pregnancy in women with IBD. The resulting abstract was selected as a",
    findingHighlight: "",
    pdf_link: "/files/DDW2026_PROs_and_pregnancy_outcomes_in_WISDOM_4.22.26.pdf",
    highlight_link: "/files/DDW2026_PROs_and_pregnancy_outcomes_in_WISDOM_4.22.26.pdf",
     category: "event"
  },
    {
    id: "04",
    title: "Advanced Therapy and Non-Pelvic Surgery Do Not Affect Time to Pregnancy in Women with Inflammatory Bowel Disease",
    authors: "Gottlieb ZS, Shmidt E, Helmus D, Wu M, Rajauria P, Persaud T, Cohen E, Dubinsky MC",
    date: "Crohn’s & Colitis Congress – January 2026",
    finding: "Interim analysis of WIsDoM data revealed that preconception exposure to advanced therapy (biologics, small molecules) was not associated with increased time to pregnancy. However, consistent with prior findings, prior pelvic IBD surgery significantly increased time to pregnancy in this population.",
    findingHighlight: "",
    highlight_link: "/files/CCC poster_meds_v4.pdf",
    pdf_link: "/files/CCC poster_meds_v4.pdf",
    category: "event"
  },
    
  {
    id: "06",
    title: "Advanced Therapies Do Not Impact Time to Pregnancy Among Women With IBD",
    authors: "",
    date: "M.D. Alert Interview – Crohn’s & Colitis Congress (CCC)",
    finding: "Expert interview highlighting WIsDoM findings demonstrating that advanced therapies do not adversely impact time to pregnancy, helping inform treatment decisions for women with IBD planning pregnancy.",
    findingHighlight: "British Journal of Surgery – Editorial",
    highlight_link: "https://www.mdalert.com/all-access/ccc2026/aa-ccc2026-article-6",
    pdf_link: "",
    category: "media"
  },
   {
    id: "07",
    title: "British Rates and Fertility Are Not the Same",
    authors: "",
    date: "British Journal of Surgery - Editorial",
    finding: "This editorial emphasizes that birth rates are not an accurate measure of fertility and underscores the importance of evaluating true fertility outcomes, particularly in populations such as women with IBD.",
    findingHighlight: "Published in British Journal of Surgery",
    highlight_link: "https://doi.org/10.58974/bjss/azbc118",
    pdf_link: "",
    category: "article"
  },

  // Add more blocks here
];